/* import __COLOCATED_TEMPLATE__ from './fly-grouped-checklist.hbs.js'; */
import Component from '@glimmer/component';
/**
  FlyGroupedChecklist renders a collection of checkboxes for users to select. Each
  group is collapsable to allow for a number of options to be present, but
  hidden if there are a lot of them.

  ## Using the FlyGroupedChecklist component

  ```hbs
  <FlyGroupedChecklist
    \@groups={{this.groups}}
    \@selectedItems={{this.selectedItems}}
    \@onChange={{this.handleChange}}
    \@disabled={{false}}
  />
  ```

  @class FlyGroupedChecklist
  @public
*/
export default class FlyGroupedChecklist extends Component {}